import { message } from 'antd'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import { CargoApi } from '../../../api/Purchase/Cargo'
import { OrdersApi } from '../../../api/Purchase/Orders'
import Cargo from '../../../components/Purchasing/Cargo/Cargo'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useModalData from '../../../elements/Hooks/useModalData'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useTitle from '../../../elements/Hooks/useTitle'
import { get, isEmpty } from 'lodash'
import React from 'react'

function CargoCont() {
  useTitle('Cargo')
  const { list, fetching, fetch } = useFetchList(() => CargoApi.list())

  // const list = listUnfiltered.filter(l => l.locked !== true)

  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const { data: centers } = useFetchURL(`foxxapi/centers?select=_id,name,_parent`)


  const selectionRawData = selection.map(s => list.find(p => get(p, '_id') === s))
  const firstSelectedCurrentRoute = get(
    get(selectionRawData, '[0].routes', [])
      .filter(r => r.hasFreightBooking === false)
      .sort(r => r.index),
    '[0]',
    {},
  )
  const selectionData = isEmpty(selectionRawData)
    ? list
    : list.filter(v => {
        const remainingRoutes = v.routes.filter(r => r.hasFreightBooking === false)
        const currentRoute = remainingRoutes.sort(r => r.index)[0]

        const sameFromLoCode =
          get(currentRoute, 'start.location.location') ===
          get(firstSelectedCurrentRoute, 'start.location.location')
        const sameToLoCode =
          get(currentRoute, 'end.location.location') ===
          get(firstSelectedCurrentRoute, 'end.location.location')

        return sameToLoCode && sameFromLoCode
      })

  const { list: OrdersList, fetching: fetchingOrders, fetch: fetchOrders } = useFetchList(
    OrdersApi.list,
  )

  const cachedListOrders = OrdersList.filter(
    o => o.category === 'Freight' || o.type === 'Freight Booking',
  )

  const {
    list: listOrders,
    company: companyOrder,
    onChangeCompany: onChangeCompanyOrder,
  } = useListCompanyFilter(cachedListOrders, fetchingOrders)

  const {
    visible,
    modalType,
    object: cargo,
    setObject: setCargo,
    submitting,
    checkForm,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
  } = useModalData()

  async function submit() {
    let newObject = await checkForm()
    newObject.cargos = selection
    newObject.currentRoute = selectionRawData.map(d =>
      get(
        d.routes.filter(r => r.hasFreightBooking === false).sort(r => r.index),
        '[0]',
        {},
      ),
    )
    setSubmitting(true)
    try {
      await CargoApi.createFreight(newObject)
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage || e)
    }
    setSubmitting(false)
  }

  return (
    <Cargo
      {...{
        list,
        fetching,
        fetch,
        tableRef,
        selection,
        selectAll,
        setSelection,
        selectionData,
        toggleSelection,
        selectionRawData,
        toggleAll,
        isSelected,
        cachedListOrders,
        fetchingOrders,
        fetchOrders,
        listOrders,
        companyOrder,
        onChangeCompanyOrder,
        visible,
        modalType,
        cargo,
        setCargo,
        submitting,
        checkForm,
        formRef,
        onShow,
        centers,
        onCancel,
        setSubmitting,
        isNew,
        submit,
      }}
    />
  )
}

CargoCont.propTypes = {}
CargoCont.defaultProps = {}

export default CargoCont
